import {
  GET_EXCO_INFO_MODAL_DATA_REQUEST,
  GET_EXCO_INFO_MODAL_DATA_SUCCESS,
  RESET_EXCO_INFO_MODAL_DATA,
  SEND_EXCO_INFO_ERROR,
  SEND_EXCO_INFO_REQUEST,
  SEND_EXCO_INFO_SUCCESS,
  SET_MODAL_VISIBILITY,
  GET_CHECK_PENDING_CHANGES_SUCCESS,
  SET_MODAL_EMPLOYEE,
  SET_PENDING_CHANGES_LOADING,
} from 'modules/SalaryModule/SalaryModal/actions';
import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';

const initialState = {
  infoModal: {
    isVisible: false,
    info: {
      totalAbsences: '',
      totalVacations: '',
      totalRewards: '',
    },
    lastFinalization: '',
    lastDeclarationPeriod: '',
    employee: {
      id: null,
      name: null,
    },
  },
  sendingStatus: STATUS_NOT_REQUESTED,
  status: STATUS_NOT_REQUESTED,
  isPendingChanges: false,
  isLoading: false,
};

export const salaryModuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MODAL_VISIBILITY:
      return {
        ...state,
        infoModal: { ...state.infoModal, isVisible: action.payload },
      };

    case SEND_EXCO_INFO_REQUEST:
      return { ...state, sendingStatus: STATUS_LOADING };

    case SEND_EXCO_INFO_SUCCESS:
      return { ...state, sendingStatus: STATUS_SUCCESS };

    case SEND_EXCO_INFO_ERROR:
      return { ...state, sendingStatus: STATUS_ERROR };

    case GET_EXCO_INFO_MODAL_DATA_REQUEST:
      return { ...state, status: STATUS_LOADING };

    case GET_EXCO_INFO_MODAL_DATA_SUCCESS: {
      const {
        data: { lastFinalization, lastDeclarationPeriod, ...data },
      } = action.payload;

      return {
        ...state,
        status: STATUS_SUCCESS,
        infoModal: {
          ...state.infoModal,
          info: data,
          lastFinalization:
            lastFinalization ?? state.infoModal.lastFinalization,
          lastDeclarationPeriod:
            lastDeclarationPeriod ?? state.infoModal.lastDeclarationPeriod,
        },
      };
    }

    case RESET_EXCO_INFO_MODAL_DATA:
      return {
        ...initialState,
        infoModal: {
          ...initialState.infoModal,
          lastFinalization: state.infoModal.lastFinalization,
          lastDeclarationPeriod: state.infoModal.lastDeclarationPeriod,
        },
        isLoading: state.isLoading,
      };

    case GET_CHECK_PENDING_CHANGES_SUCCESS:
      return { ...state, isPendingChanges: action.payload };

    case SET_MODAL_EMPLOYEE:
      return {
        ...state,
        infoModal: { ...state.infoModal, employee: action.payload },
      };

    case SET_PENDING_CHANGES_LOADING:
      return { ...state, isLoading: action.payload };

    default:
      return state;
  }
};
